/* DataExplorerDetailsViewRenderer.js */

"use strict";
// require("@gluenetworks/jstree");
const _ = require("lodash");
// const $ = require('jquery');
const Forms = require("@gluenetworks/forms");
const FormsComponent = Forms.ui.component;
const formatters = require("./cellFormaters");
const fieldEditor = require("./cellEditors/FieldEditor");
const inputTextEditor = require("./cellEditors/InputTextEditor");
const sortTypeEditor = require("./cellEditors/SortTypeEditor");
const aggregatorEditor = require("./cellEditors/AggregatorEditor");
const checkboxEditor = require("./cellEditors/CheckBoxEditor");

const SortOptionsComponent = require("./veils/SortOptionsComponent");

const ConditionalFormatVeil = require("./veils/conditionalFormatting/ConditionalFormattingComponent");

/* global Slick */
require("moment-duration-format");

// const readOnlyFieldIds = ["createdOn", "createdBy", "updatedBy", "updatedOn"];

class DataExlporerDetailsViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("data-explorer-details-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._formsComponent = new FormsComponent();

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Save As",
            name: "SaveAs",
            handler: (this._onTemplateSaveAs = this._onTemplateSaveAs.bind(this))
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Save",
            name: "SaveTemplate",
            handler: (this._onTemplateSave = this._onTemplateSave.bind(this))
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Cancel",
            name: "CancelTemplateDetails",
            handler: (this._onTemplateDetailsCancel = this._onTemplateDetailsCancel.bind(this))
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Add Row",
            name: "addRow",
            handler: (this._addNewRowAction = this._addNewRowAction.bind(this)),
            position: "left"
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Sort Order",
            name: "sortBtn",
            handler: (this._sortOptions = this._sortOptions.bind(this)),
            position: "left"
        });

        this._hideViewActions();
        this._hasInitialSort = false;
        this._model.gameEditor.hideViewAction("sortBtn");

        this._onTemplateDetailsRefreshAction = this._onTemplateDetailsRefreshAction.bind(this);

        this._slickTableContainer = document.createElement("columns-table");
        this._slickTable = undefined;
        this._maxSortOrder = 0;
        this._columns = [
            {
                id: "order",
                width: 10,
                name: "",
                //field: "order",
                behavior: "selectAndMove",
                asyncPostRender: function (node) {
                    node[0].setAttribute("title", "Reorder");
                },
                selectable: false,
                resizable: false,
                cssClass: "cell-reorder dnd centered g-icon-drag",
                headerCssClass: "centered"
            },
            {
                id: "count",
                width: 20,
                name: "",
                tooltip: "Row number",
                selectable: false,
                resizable: false,
                cssClass: "cell-reorder dnd centered",
                headerCssClass: "centered",
                formatter: formatters.countFormatter
            },
            {
                id: "field",
                width: 150,
                name: "Field",
                field: "field",
                toolTip: "field",
                formatter: formatters.fieldFormatter,
                editor: fieldEditor
            },
            // {
            //     id: "dheading",
            //     width: 100,
            //     name: "Default Column Title",
            //     field: "dheading",
            //     toolTip: "Default Column Title",
            //     cssClass:"default-heading read-only"
            // },
            {
                id: "heading",
                width: 80,
                name: "Column Title",
                field: "heading",
                toolTip: "When there is more than one column with the same title, {$idx} will be replaced with '1', '2', '3', etc., in the report.",
                editor: inputTextEditor,
                formatter: formatters.headingFormatter
            },
            {
                id: "visible",
                width: 30,
                name: "Visible",
                field: "visible",
                toolTip: "Visible",
                editor: checkboxEditor,
                formatter: formatters.checkboxFormatter,
                cssClass: "centered",
                headerCssClass: "centered"
            },
            {
                id: "aggregator",
                width: 50,
                name: "Calculation",
                field: "aggregator",
                toolTip: "Aggregator method",
                editor: aggregatorEditor,
                formatter: formatters.aggregateFormatter
            },
            {
                id: "sortType",
                width: 50,
                name: "Sort Type",
                field: "sortType",
                toolTip: "Sort Type",
                editor: sortTypeEditor,
                formatter: formatters.sortTypeFormatter
            },
            {
                id: "sortOrder",
                width: 20,
                name: "Sort Order",
                field: "sortOrder",
                toolTip: "Sort Order",
                formatter: formatters.sortOrderFormatter,
                cssClass: "centered",
                headerCssClass: "centered"
            },
            {
                id: "rowOrientation",
                width: 50,
                name: "Row Oriented",
                field: "rowOrientation",
                toolTip: "Row Orientation true/false",
                formatter: formatters.rowOrientationFormatter,
                cssClass: "centered row-orientation",
                headerCssClass: "centered"
            },
            {
                id: "conditionalFormat",
                width: 70,
                name: "Conditional Formatting",
                field: "conditionalFormat",
                toolTip: "Conditional Formatting",
                formatter: formatters.conditionalFormat,
                cssClass: "centered",
                headerCssClass: "centered"
            },
            {
                id: "deleteRow",
                width: 50,
                name: "",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: formatters.deleteButtonFormatter,
                headerCssClass: "centered"
            }
        ];

        this._tableOptions = {
            editable: false,
            enableCellNavigation: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoHeight: false,
            autoEdit: true,
            resizable: true,
            rowHeight: 40
        };

        this._renderingForm = false;

        this._onRowCountChange = this._onRowCountChange.bind(this);
        this._onCellChange = this._onCellChange.bind(this);
        this._onSlickClick = this._onSlickClick.bind(this);
        this._onSlickDblClick = this._onSlickDblClick.bind(this);
        this._onBeforeEditCell = this._onBeforeEditCell.bind(this);
        this.bodyMutationCb = this.bodyMutationCb.bind(this);
        this.editorMutationCb = this.editorMutationCb.bind(this);
        this._onWindowResized = _.debounce(this._onWindowResized.bind(this), 100);

        this._bodyObs = new MutationObserver(this.bodyMutationCb);
        this._mutObsConf = { attributes: true, childList: true, subtree: true };
        this._bodyObs.observe(document.body, this._mutObsConf);

        this._editorObs = undefined;

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Dirty", (this._onDirty = this._onDirty.bind(this)));
        this._model.on("SortAvailableChange", (this._onSortAvailableChange = this._onSortAvailableChange.bind(this)));
        this._model.on("RefreshView", this._onTemplateDetailsRefreshAction);
        this._formsComponent.on(
            "PendingPatchesChanged",
            (this._onFormsPendingPatchesChanged = _.debounce(this._onFormsPendingPatchesChanged.bind(this), 500, false))
        );

        window.addEventListener("resize", this._onWindowResized);
        // document.addEventListener("click", this._clickHandler = this._clickHandler.bind(this));
    }

    _unregisterListeners() {
        this._model.removeListener("Dirty", this._onDirty);
        this._formsComponent.removeListener("PendingPatchesChanged", this._onFormsPendingPatchesChanged);
        this._model.removeListener("RefreshView", this._onTemplateDetailsRefreshAction);
        // document.removeEventListener("click", this._clickHandler);
        window.removeEventListener("resize", this._onWindowResized);
    }

    _registerSlickListeners() {
        if (this._slickTable) {
            this._slickDataVIew.onRowCountChanged.subscribe(this._onRowCountChange);
            this._slickDataVIew.onRowsChanged.subscribe(this._onRowCountChange);
            this._slickTable.onCellChange.subscribe(this._onCellChange);
            this._slickTable.onClick.subscribe((this._onSlickClick = this._onSlickClick.bind(this)));
            this._slickTable.onDblClick.subscribe((this._onSlickDblClick = this._onSlickDblClick.bind(this)));
            this._slickTable.onSelectedRowsChanged.subscribe((this._onSlickSelectedRowsChanged = this._onSlickSelectedRowsChanged.bind(this)));
            this._slickTable.onBeforeEditCell.subscribe(this._onBeforeEditCell);
        }
    }

    _unregisterSlickListeners() {
        if (this._slickTable) {
            this._slickDataVIew.onRowCountChanged.unsubscribe(this._onRowCountChange);
            this._slickDataVIew.onRowsChanged.unsubscribe(this._onRowCountChange);
            this._slickTable.onCellChange.unsubscribe(this._onCellChange);
            this._slickTable.onClick.unsubscribe(this._onSlickClick);
            this._slickTable.onClick.unsubscribe(this._onSlickDblClick);
            this._slickTable.onSelectedRowsChanged.unsubscribe(this._onSlickSelectedRowsChanged);
            this._slickTable.onBeforeEditCell.unsubscribe(this._onBeforeEditCell);
        }
    }

    bodyMutationCb(mutationsList) {
        // Use traditional 'for loops' for IE 11
        for (let mutation of mutationsList) {
            if (mutation.type === "childList" && mutation.target === document.body && mutation.addedNodes.length > 0) {
                // console.log(mutation.addedNodes);
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    if (mutation.addedNodes[i].classList.contains("de-editor-wrapper") && mutation.addedNodes[i].classList.contains("field-editor")) {
                        // console.log(mutation.addedNodes[i]);
                        this.adjustFieldEditorPosition(mutation.addedNodes[i]);
                        this.unsetEditorMutationObserver();
                        this.setEditorMutationObserver(mutation.addedNodes[i]);
                        return;
                    }
                }
            }
        }
    }

    editorMutationCb(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "style") {
                this.adjustFieldEditorPosition(mutation.target);
            }
        }
    }

    adjustFieldEditorPosition(el) {
        const top = el.offsetTop;
        const elHeight = 200;
        const offsetBy = 40;
        const docHeight = document.body.clientHeight - 20;
        if (docHeight < top + elHeight) {
            el.style.top = `${top - elHeight + offsetBy}px`;
        }
    }

    setEditorMutationObserver(el) {
        this._editorObs = new MutationObserver(this.editorMutationCb);
        const conf = { attributes: true };
        this._editorObs.observe(el, conf);
    }

    unsetEditorMutationObserver() {
        if (this._editorObs) {
            this._editorObs.disconnect();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._bodyObs.disconnect();
        this.unsetEditorMutationObserver();
        this._unregisterListeners();
        this._unregisterSlickListeners();
        this._onFormsPendingPatchesChanged.flush();
        let promArr = [this._formsComponent.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "DataExlporerDetailsViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._formsComponent.renderer.rootElement);
        }
        return this._model.whenModelIsReady().then(
            () => {
                // TODO : ADD RENDER METHOD HERE
                if (!this._model._isOwnUser && !this._model._hasModeratorAuth) {
                    this._model.gameEditor.disableViewAction("sortBtn");
                    this._model.gameEditor.disableViewAction("addRow");
                }
                this._tableOptions.editable = this._model._isOwnUser || this._model._hasModeratorAuth;
                this.rootElement.appendChild(this._formsComponent.renderer.rootElement);
                this._rootElem.appendChild(this._slickTableContainer);
                let data = this._generateSlickData();
                // data[0] = this._generateSlickRow(0);
                this._slickDataVIew = new Slick.Data.DataView();
                this._slickDataVIew.setItems(data);
                this._slickDataVIew.getItemMetadata = ((original_getItemMetadata) => (row) => {
                    // const item = this._slickDataVIew.getItem(row);
                    let ret = original_getItemMetadata(row);
                    if (row === this._slickDataVIew.getLength() - 1) {
                        ret = ret || {};
                        ret.cssClasses = (ret.cssClasses || "") + " " + "bordered";
                    } else {
                        if (ret && ret.cssClasses && typeof ret.cssClasses === "string") {
                            ret.cssClasses = ret.cssClasses.replace("bordered", "");
                        }
                    }
                    return ret;
                })(this._slickDataVIew.getItemMetadata);
                this._slickTable = new Slick.Grid(this._slickTableContainer, this._slickDataVIew, this._columns, this._tableOptions);
                this._slickTable.maxSortOrder = this._maxSortOrder;
                this._slickTable.rowOrientationKey = this._model._rowOrientationKey;
                this._slickTable.setSelectionModel(new Slick.RowSelectionModel());
                this._registerRowMovePlugin(this._slickTable, this._slickDataVIew);
                // this._slickTable.registerPlugin(this._slickRadio);
                // this._addBorderToLastRow();
                this._registerSlickListeners();

                this._renderTemplateDetailsForm();
            },
            (err) => err
        );
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    _showViewActions() {
        if (!this._model._isOwnUser && !this._model._hasModeratorAuth) {
            return;
        }
        this._model.gameEditor.showViewAction("SaveTemplate");
        this._model.gameEditor.showViewAction("CancelTemplateDetails");
        this._model.gameEditor.showViewAction("SaveAs");
    }

    _hideViewActions() {
        this._model.gameEditor.hideViewAction("SaveTemplate");
        this._model.gameEditor.hideViewAction("CancelTemplateDetails");
        this._model.gameEditor.hideViewAction("SaveAs");
    }

    _disableViewActions() {
        this._model.gameEditor.disableViewAction("SaveTemplate");
        this._model.gameEditor.disableViewAction("CancelTemplateDetails");
        this._model.gameEditor.disableViewAction("SaveAs");
    }

    _enableViewActions() {
        this._model.gameEditor.enableViewAction("SaveTemplate");
        this._model.gameEditor.enableViewAction("CancelTemplateDetails");
        this._model.gameEditor.enableViewAction("SaveAs");
    }

    _toggleActions(state) {
        if (state) {
            this._showViewActions();
        } else {
            this._hideViewActions();
        }
    }
    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderTemplateDetailsForm() {
        let jtype = this._getJtype();
        let pristineValue = this._convertToForm(
            this._model._templateEntity.getPristineProperties(),
            this._model._isOwnUser || this._model._hasModeratorAuth
        );
        // let updatedPristineValue = this._updatePristineValueStatus(pristineValue);
        this._formsComponent.setTypeInformation(jtype, true);
        this._formsComponent.setPristineValue(pristineValue, true);
        this._renderingForm = true;

        return this._formsComponent.renderer.render().then(() => {
            this._renderingForm = false;
            return Promise.resolve();
        });
    }

    _convertToForm(vals, isOwnUser = false) {
        const updatedData = {
            one: {
                name: vals.name,
                description: vals.description,
                rowOrientedProp: vals.rowOrientedProp
            },
            two: {
                defaultFor: {
                    defaultForDm: isOwnUser ? vals.defaultForDm : undefined,
                    defaultForCda: isOwnUser ? vals.defaultForCda : undefined,
                    defaultForOsm: isOwnUser ? vals.defaultForOsm : undefined
                },
                perms: {
                    shared: vals.shared,
                    private: vals.private
                        ? "Private (only I can configure and run this template)"
                        : "Public (all users can run this template but cannot configure)"
                }
            }
        };

        return updatedData;
    }

    _convertFromForm(vals) {
        const updatedData = {
            name: vals.one.name,
            description: vals.one.description || "",
            shared: vals.two.perms.shared,
            private: _.get(vals, "two.perms.private", "Private").search("Private") >= 0 ? true : false,
            rowOrientedProp: vals.one.rowOrientedProp,
            defaultForDm: vals.two.defaultFor.defaultForDm,
            defaultForCda: vals.two.defaultFor.defaultForCda,
            defaultForOsm: vals.two.defaultFor.defaultForOsm
        };
        return updatedData;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/
    // _clickHandler(evt) {
    //     if(evt.target.className && typeof evt.target.className === "string" && evt.target.className.search("slick") < 0 && this._slickTable) {
    //         // this._slickTable.getEditorLock().commitCurrentEdit();
    //     }
    // }
    _onFormsPendingPatchesChanged() {
        if (!this._model._isOwnUser && !this._model._hasModeratorAuth) {
            return;
        }
        if (!_.isEmpty(this._model)) {
            const form = this._formsComponent.getValue();
            if (!this._renderingForm) {
                const entityVals = this._convertFromForm(form);
                for (let key in entityVals) {
                    this._model._templateEntity[key] = entityVals[key];
                }
                if (this._model._templateEntity.rowOrientedProp !== this._model._rowOrientationKey) {
                    this._model._rowOrientationKey = this._model._templateEntity.rowOrientedProp;
                    this._slickTable.rowOrientationKey = this._model._rowOrientationKey;
                    this._updateGridForRowOrientation(this._model._templateEntity.rowOrientedProp);
                }
            }
        }
    }

    // _onFilePropertiesChanged(pristineProperties, before) {
    //     console.log(pristineProperties, before);
    // }

    _onDirty(dirtyState) {
        this._toggleActions(dirtyState);
    }

    _onSortAvailableChange(hasSort) {
        if (hasSort) {
            this._model.gameEditor.showViewAction("sortBtn");
        } else {
            this._model.gameEditor.hideViewAction("sortBtn");
        }
    }

    _onTemplateSave() {
        // console.log(this._model._templateEntity.isDirty());
        // console.log(this._model._templateEntity);
        this._model
            ._saveTemplate()
            .then(() => {
                this._hideViewActions();
            })
            .catch((err) => {
                if (err.userRejected) {
                    return Promise.resolve();
                } else {
                    this._logger.error("Error saving the template:", err);
                }
            });
    }

    _onTemplateSaveAs() {
        const form = this._formsComponent.getValue();
        const formVals = this._convertFromForm(form);
        this.model._requestTemplateCreate(false, formVals, this._slickTable.getData().getItems());
    }

    _onTemplateDetailsCancel() {
        this.model.gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: "Are you sure you want to cancel? All changes will be lost.",
                title: "Cancel Confirmation Check",
                confirmDetails: {
                    text: "Yes",
                    type: "text"
                }
            },
            (this._onTemplateDetailsRefreshAction = this._onTemplateDetailsRefreshAction.bind(this))
        );
    }

    _onTemplateDetailsRefreshAction() {
        return this._model._clearChanges().then(() => {
            /* reset Slick table */
            this._maxSortOrder = 0;
            let data = this._generateSlickData();
            this._slickTable.maxSortOrder = this._maxSortOrder;
            this._slickDataVIew.setItems(data);
            this._slickDataVIew.refresh();
            this._slickTable.invalidateAllRows();
            this._slickTable.resizeCanvas();
            // this._addBorderToLastRow();

            /* reset form */
            let pristineValue = this._convertToForm(
                this._model._templateEntity.getPristineProperties(),
                this._model._isOwnUser || this._model._hasModeratorAuth
            );
            this._formsComponent.setPristineValue(pristineValue);

            /* sort button */
            if (this._hasInitialSort) {
                this._model.gameEditor.showViewAction("sortBtn");
            }

            if (!this._model._isOwnUser && !this._model._hasModeratorAuth) {
                this._gameEditor._tabCmpnt.setDirty(false);
            }
        });
    }

    _addNewRowAction(/*e, args*/) {
        let item = Object.assign(this._generateSlickRow(), { complete: false });
        this._slickDataVIew.addItem(item);
        const _row = this._slickDataVIew.getRowById(item.id);
        // wait for render
        _.delay(() => {
            this._slickTable.scrollRowToTop(_row);
            this._slickTable.setActiveCell(_row, 1);
            this._slickTable.editActiveCell();
        }, 100);
        // this._setActionButtonsAvailability(true);
    }

    _sortOptions() {
        this._model._modalUserFeedback
            .displayCustom(new SortOptionsComponent(this._logger, this._slickDataVIew, this._model._sortData), {
                dontHide: false
            })
            .then(() => {
                this._setColumnsOnSlickChanges(this._slickTable);
                this._slickDataVIew.refresh();
                this._slickTable.invalidateAllRows();
                this._slickTable.resizeCanvas();
                // this._addBorderToLastRow();
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._logger.warn({ error: err }, "Sort options - User Canceled");
                    return;
                } else {
                    this._logger.warn({ error: err }, "Sort options - Error");
                    return this._modalUserFeedback.displayError(err);
                }
            });
    }

    _onRowCountChange(/*e, {previous, current, dataView, callingOnRowsChanged}*/) {
        // this._slickTable.invalidateAllRows();
        // this._slickTable.resizeCanvas();
        this._slickTable.updateRowCount();
        this._slickDataVIew.refresh();
        this._slickTable.invalidateAllRows();
        this._slickTable.resizeCanvas();
        // this._addBorderToLastRow();
        this._setColumnsOnSlickChanges(this._slickTable);
        // this._toggleNoDataPlaceholder(!current);
    }

    _onCellChange(e, args) {
        this._setColumnsOnSlickChanges(args.grid);
        if (args.grid.getColumns()[args.cell].id === "sortType") {
            args.grid.invalidateAllRows();
            args.grid.render();
        }
    }

    _setColumnsOnSlickChanges(grid) {
        // console.log("_setColumnsOnSlickChanges :: called");
        const _sorted = this._model._fixSortOrder(grid.getData().getItems());
        this._maxSortOrder = _sorted.length;
        this._slickTable.maxSortOrder = this._maxSortOrder;
        const columns = this._model._generateColumns(grid.getData().getItems());
        this._model._templateEntity.setColumns(columns);
    }

    _onSlickDblClick(e, args) {
        const { cell, grid } = args;
        const cellid = grid.getColumns()[cell].id;

        if (cellid === "sortOrder" && this._maxSortOrder > 0) {
            this._sortOptions();
        }
    }

    _onSlickClick(e, args) {
        const { row, cell, grid } = args;
        const cellid = grid.getColumns()[cell].id;

        if (!this._model._isOwnUser && !this._model._hasModeratorAuth && cellid !== "conditionalFormat") {
            return;
        }
        const data = grid.getData();
        const rowData = data.getItem(row);
        const rowId = rowData.id;
        if (cellid === "deleteRow") {
            this._model._modalUserFeedback
                .displayConfirmation(`Are you sure you want to delete the row of ${rowData.field.replace(/>/g, " > ")}?`, {
                    title: "Delete Row",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive"
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text"
                    }
                })
                .then(() => {
                    data.deleteItem(rowId);
                    // data.refresh();
                    grid.invalidateAllRows();
                    grid.render();
                    return Promise.resolve();
                })
                .catch((err) => {
                    this._logger.warn("Row not deleted", err);
                });
        }

        if (cellid === "conditionalFormat") {
            if (grid.getCellNode(row, cell).children("[disabled]").length > 0) {
                return;
            }
            const data = grid.getData();
            const item = data.getItem(row);
            // console.log(item);
            const isConditionalFormatEnabled = (this._model._isOwnUser || this._model._hasModeratorAuth) && !item.isUnavailable;
            this._rowConditionalFormat(item, isConditionalFormatEnabled);
        }

        // if(cellid === "rowOrientation" && e.target.tagName === "INPUT") {
        //     // this._setDefaultHeading(e.target.checked, row, cell, grid);
        //     // grid.invalidateAllRows();
        //     // grid.render();
        //     // this._setColumnsOnSlickChanges(grid);
        // }
    }

    _onSlickSelectedRowsChanged(/*evt, {rows, grid}*/) {
        // since ctrl + click doesnt emit slick click uncheking radio here, shift+click, ctrl + click
        // if(!this._model._isOwnUser) {
        //     return;
        // }
        // const cellNode = grid.getActiveCellNode();
        // const activeCell = grid.getActiveCell();
        // if(!activeCell) {
        //     return;
        // }
        // const {row, cell} = activeCell;
        // if(cellNode.hasClass("row-orientation") && cellNode[0].querySelector("input")) {
        //     cellNode[0].querySelector("input").checked = false;
        //     this._setDefaultHeading(false, row, cell, grid);
        //     grid.invalidateAllRows();
        //     grid.render();
        //     this._setColumnsOnSlickChanges(grid);
        // }
        // const fieldData = grid.getData().getItems()[rows[0]];
        // this._model._templateEntity.setRowOrientedProp(fieldData.field);
    }

    _onBeforeEditCell(evt, args) {
        const currEle = args.grid.getCellNode(args.row, args.cell);
        if (currEle.children(".disabled").length > 0) {
            return false;
        }
        return true;
    }

    _onWindowResized() {
        this._slickTable.resizeCanvas();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _getPristineValue() {
        return this._model.osImagePristineValues;
    }
    _getJtype() {
        let jtype = {};
        // jtype["@Display.layout.flex-container"] = {
        //     "flex-wrap": "wrap"
        // };
        jtype.one = {};
        jtype["one@Display.label"] = "";
        jtype.one.name = "";
        jtype.one["name@Display.label"] = "Name";

        // jtype.one.rowOrientedProp = "";
        // jtype.one["rowOrientedProp@Display.label"] = "Row Orientation";
        // jtype.one["rowOrientedProp@Display.placeholder"] = "detectedStack";

        jtype.one.description = "";
        jtype.one["description@Display.label"] = "Description";

        jtype.one.rowOrientedProp = "";
        jtype.one["rowOrientedProp@Display.label"] = "Row Orientation";
        jtype.one["rowOrientedProp@Display.enum"] = Object.values(this._model._rowOrientationGroups);
        jtype.one["rowOrientedProp@Enum"] = Object.keys(this._model._rowOrientationGroups);

        if (!this._model._isOwnUser && !this._model._hasModeratorAuth) {
            for (let key in jtype.one) {
                jtype.one[key + "@Display.readOnly"] = true;
            }
        }

        jtype.two = {};
        jtype["two@Display.label"] = "";

        jtype.two.defaultFor = {};
        jtype.two["defaultFor@Display.label"] = "";

        jtype.two.defaultFor.defLabel = "";
        jtype.two.defaultFor["defLabel@Display.label"] = "Default for";

        jtype.two.defaultFor.defaultForDm = false;
        jtype.two.defaultFor["defaultForDm@Display.label"] = "Device Manager";
        jtype.two.defaultFor.defaultForCda = false;
        jtype.two.defaultFor["defaultForCda@Display.label"] = "Config Drift and Audit";
        jtype.two.defaultFor.defaultForOsm = false;
        jtype.two.defaultFor["defaultForOsm@Display.label"] = "OS Manager";

        if (!this._model._isOwnUser && !this._model._hasModeratorAuth) {
            for (let key in jtype.two.defaultFor) {
                jtype.two.defaultFor[key + "@Display.readOnly"] = true;
            }
        }

        jtype.two.perms = {};
        jtype.two["perms@Display.label"] = "";

        jtype.two.perms.permLabel = "";
        jtype.two.perms["permLabel@Display.label"] = "Permissions";

        jtype.two.perms.private = false;
        jtype.two.perms["private@Display.label"] = "";
        jtype.two.perms["private@Display.radioButton.horizontal"] = false;
        jtype.two.perms["private@Enum"] = [
            "Private (only I can configure and run this template)",
            "Public (all users can run this template but cannot configure)"
        ];
        jtype.two.perms.shared = false;
        jtype.two.perms["shared@Display.label"] = "Make this template also available in subordinate organizations";

        if (!this._model._isOwnUser && !this._model._hasModeratorAuth) {
            for (let key in jtype.two.perms) {
                jtype.two.perms[key + "@Display.readOnly"] = true;
            }
        }

        return jtype;
    }

    _generateSlickRow(idx) {
        let _rand;
        if (window.crypto) {
            _rand = window.crypto.getRandomValues(new Uint8Array(3)).join(parseInt(Math.random() * 100, 10) + "_");
        } else {
            _rand = parseInt(Math.random() * 10000, 10) * parseInt(Math.random() * 100 + 1, 10);
        }
        const id = idx || _rand;
        const row = {};
        row.id = `id_${id}`;
        row.solutions = this._model._explorablesEntity.getExplorables();
        row.treeData = this._model._dataForTree;
        const category = "General";
        const fieldName = "Name";
        row.field = `${category}>${fieldName}`;
        row.dataType = row.solutions[category][fieldName].dataType;
        // row.dheading = row.solutions[category][fieldName].heading;
        row.heading = row.solutions[category][fieldName].heading;
        row.sortOrder = undefined;
        row.visible = true;
        row.rowOrientation = false;
        row.isOwner = this._model._isOwnUser;

        return row;
    }

    _generateSlickData() {
        this._hasInitialSort = false;
        const columns = this._model._templateEntity.getColumns();
        // console.log(columns);
        const rowOrientation = this._model._templateEntity.getRowOrientedProp();
        if (!columns || columns.length < 1) {
            return [this._generateSlickRow()];
        }
        const slickData = columns
            .map((column, idx) => {
                // using index from array to be unique and __ to differ from genrow
                const id = parseInt(Math.random() * 10000, 10) + "__" + idx;
                const row = {};
                row.solutions = this._model._explorablesEntity.getExplorables();
                row.field = this._model.findFlattenedPath(row.solutions, column.path);
                row.path = column.path;
                if (!row.field) {
                    row.field = column.flattenedPath;
                    row.isUnavailable = true;
                }
                row.id = `id_${id}`;
                row.treeData = this._model._dataForTree;
                row.isOwner = this._model._isOwnUser;
                if (!row.field) {
                    row.isOwner = false;
                }
                // row.heading = column.heading;
                row.sortOrder = column.sort ? column.sort.order : undefined;
                if ((row.sortOrder || row.sortOrder === 0) && row.sortOrder >= this._maxSortOrder) {
                    this._maxSortOrder = row.sortOrder + 1;
                }
                row.visible = column.visible;
                row.sortType = column.sort ? (column.sort.descending ? "desc" : "asc") : false;
                row.aggregator = column.aggregator;
                row.dataType = column.dataType;
                row.typeInfo = column.typeInfo;

                row.conditionalFormat = column.formatting;
                if (column.path.indexOf(rowOrientation) >= 0) {
                    row.rowOrientation = true;
                } else {
                    row.rowOrientation = false;
                }
                // if(row.field === rowOrientation) {
                //     row.rowOrientation = true;
                // } else {
                //     row.rowOrientation = false;
                // }
                if (row.field) {
                    const defFieldData = row.field.split(">").reduce((acc, path) => {
                        if (!acc) {
                            return acc;
                        }
                        return acc[path];
                    }, row.solutions);
                    if (row.rowOrientation) {
                        row.heading = column.heading === defFieldData.heading ? defFieldData.rowOrientedValHeading : column.heading;
                        row.dheading = defFieldData.rowOrientedValHeading;
                    } else {
                        row.heading = column.heading || defFieldData.heading;
                        row.dheading = _.get(defFieldData, "heading", "");
                    }
                }
                if (row.sortType) {
                    this._hasInitialSort = true;
                }
                return row;
            })
            .filter((item) => !!item);
        if (this._hasInitialSort) {
            this._model.gameEditor.showViewAction("sortBtn");
        }
        return slickData;
    }

    _rowConditionalFormat(item, isOwner = true) {
        return this.model._modalUserFeedback
            .displayCustom(
                new ConditionalFormatVeil(
                    this._model._logger,
                    this._model._userSession,
                    this.model._modalUserFeedback,
                    item,
                    this._model._templateEntity,
                    isOwner
                ),
                { dontHide: true }
            )
            .then(() => {
                this._setColumnsOnSlickChanges(this._slickTable);
                this._slickTable.invalidateAllRows();
                this._slickTable.resizeCanvas();
                // this._addBorderToLastRow();
            })
            .catch((e) => e)
            .finally(() => {
                this._model._modalUserFeedback.hideDisplayed();
            });
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/

    _updateGridForRowOrientation(rowOrientedProp) {
        const data = this._slickDataVIew.getItems();
        const updatedData = [];
        let updateCount = 0;
        if (data.length < 1) {
            return;
        }
        data.forEach((f) => {
            if (f.field) {
                const path = f.field.split(">");
                const fi = path.reduce((acc, p) => {
                    return acc[p];
                }, f.solutions);
                if (fi.path.indexOf(rowOrientedProp) >= 0) {
                    if (fi.rowOrientedValHeading) {
                        f.heading = f.heading === fi.heading ? fi.rowOrientedValHeading : f.heading;
                        f.dheading = fi.rowOrientedValHeading;
                        f.rowOrientation = true;
                        updateCount++;
                    }
                } else {
                    if (fi.heading) {
                        f.heading = f.heading === fi.rowOrientedValHeading ? fi.heading : f.heading;
                        f.dheading = fi.heading;
                        f.rowOrientation = false;
                        updateCount++;
                    }
                }
                updatedData.push(f);
            }
        });
        if (updateCount > 0) {
            this._slickDataVIew.setItems(updatedData);
            this._slickDataVIew.refresh();
            this._slickTable.invalidateAllRows();
            this._slickTable.resizeCanvas();
            // this._addBorderToLastRow();
        }
    }

    // _addBorderToLastRow() {
    //     const _dataLength = this._slickTable.getDataLength();
    //     if(!_dataLength) {
    //         return;
    //     }
    //     const rowEl = this._slickTable.getCellNode(_dataLength-1, 1).parent(".slick-row")[0];
    //     if(!rowEl) {
    //         return;
    //     }
    //     // rowEl.classList.add("bordered");
    // }

    _registerRowMovePlugin(grid, dataView) {
        const moveRowsPlugin = new Slick.RowMoveManager({
            cancelEditOnDrag: true
        });
        // const sortingComparator = this._model.CustomFieldsEntity.getSortingComparator("order");

        moveRowsPlugin.onBeforeMoveRows.subscribe(function (e, { insertBefore, rows }) {
            rows = [...rows].sort();
            if (
                _.first(rows) === insertBefore ||
                _.last(rows) === insertBefore - 1
                // _.get(dataView.getItem(insertBefore), "inherited")
            ) {
                e.stopPropagation();
                return false;
            }
            return true;
        });
        moveRowsPlugin.onMoveRows.subscribe(function (e, args) {
            let extractedRows = [],
                left,
                right;
            let rows = args.rows;
            let insertBefore = args.insertBefore;
            let data = dataView.getItems();
            left = data.slice(0, insertBefore);
            right = data.slice(insertBefore, data.length);

            rows.sort(function (a, b) {
                return a - b;
            });

            for (let i = 0; i < rows.length; i++) {
                extractedRows.push(data[rows[i]]);
            }

            rows.reverse();

            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];
                if (row < insertBefore) {
                    left.splice(row, 1);
                } else {
                    right.splice(row - insertBefore, 1);
                }
            }

            data = left.concat(extractedRows.concat(right));

            let selectedRows = [];
            for (let i = 0; i < rows.length; i++) {
                selectedRows.push(left.length + i);
            }
            dataView.setItems(data);
            grid.resetActiveCell();
            grid.setSelectedRows(selectedRows);
            grid.invalidateAllRows();
            grid.resizeCanvas();
        });

        grid.registerPlugin(moveRowsPlugin);
    }
}

module.exports = DataExlporerDetailsViewRenderer;
